import { render } from "./tip-msg-box.vue?vue&type=template&id=77aad91f&scoped=true&ts=true"
import script from "./tip-msg-box.vue?vue&type=script&lang=ts"
export * from "./tip-msg-box.vue?vue&type=script&lang=ts"

import "./tip-msg-box.vue?vue&type=style&index=0&id=77aad91f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77aad91f"]])

export default __exports__